module.exports = __webpack_public_path__ + "static/media/5cecf4f3.jpg";